import { SetStateAction } from "react"

const identifyOs = (setOs?: (value: SetStateAction<string>) => void) => {
  let os = ""
  const { userAgent } = window.navigator
  if (userAgent.match(/Mac/i) && !userAgent.match(/iPhone|iPad/i)) {
    setOs?.("mac")
    os = "mac"
  } else if (userAgent.match(/Linux/i) && !userAgent.match(/Android/i)) {
    setOs?.("linux")
    os = "linux"
  } else if (userAgent.match(/Android/i)) {
    setOs?.("android")
    os = "android"
  } else if (userAgent.match(/iPhone|iPad/i)) {
    setOs?.("iOS")
    os = "iOS"
  } else {
    setOs?.("win")
    os = "win"
  }
  return os
}

export default identifyOs
